import { SET_NEW_PERIODS } from './constants'

export default payload => dispatch => {
    dispatch({
        type: SET_NEW_PERIODS,
        payload,
    })
}
